import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cx } from 'class-variance-authority';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailsType } from './types';

interface Props {
    details: DetailsType;
    className?: string;
    initiallyHidden?: boolean;
}

export const PaymentMethodDetails = ({ details, className, initiallyHidden = false }: Props) => {
    const [hidden, setHidden] = useState(initiallyHidden);
    const { t } = useTranslation('mollie');

    const renderKeyValue = (value: any) => {
        if (value)
            if (typeof value === 'object') {
                return Object.values(value).join(' ');
            }

        return value;
    };

    return details ? (
        hidden ? (
            <span
                className="tw-inline-block tw-w-full tw-cursor-pointer tw-text-center tw-text-xs tw-text-accents-6"
                onClick={() => setHidden(false)}
            >
                Mehr anzeigen <FontAwesomeIcon className="tw-ml-2" icon={faChevronDown} />
            </span>
        ) : (
            <div className={cx('tw-grid tw-grid-cols-2 tw-gap-x-2 tw-text-xs', className)}>
                {Object.entries(details)
                    .filter(([key]) => key !== 'cardFingerprint')
                    .map(([key, value]) => (
                        <React.Fragment key={key}>
                            <span className="tw-inline-block tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-font-semibold">
                                {t('details.' + key)}
                            </span>
                            <span className="tw-inline-block tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
                                {renderKeyValue(value) || 'k. D.'}
                            </span>
                        </React.Fragment>
                    ))}
            </div>
        )
    ) : (
        <small className="text-muted">Keine weiteren Zahlungsdaten verfügbar.</small>
    );
};
